module.exports = __webpack_public_path__ + "img/kinnaps-pic.a9176655.png";